import styled from '../../../styled';
const Body = styled.div `
  flex: 1;
  overflow: auto;
  font-size: 0.875rem;
  font-weight: 500;

  ${({ noContent }) => noContent &&
    `
    display: flex;
    justify-content: center;
    align-items: center;
  `}
`;
export default Body;
//# sourceMappingURL=Body.js.map